module.exports = __webpack_public_path__ + "media/images/project/eye-arrow-f2b38ed67a02ee7e07c9a0f75c70ba71.svg";